import DeleteIcon from 'assets/settings/components/DeleteIcon';
import EditIcon from 'assets/settings/components/EditIcon';

import {
  ActionButton,
  ActionsSection,
  Card,
  ContentSection,
  Description,
  IconWrapper,
  StatusBadge,
  Title,
} from './ProductCard.styles';

const ProductCard = ({ icon, title, status, description, onEdit, onDelete }) => {
  const truncateText = (text, maxLength = 20) => {
    if (!text) return '';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  return (
    <Card>
      <ContentSection>
        <IconWrapper>{icon}</IconWrapper>
        <Title title={title}>{truncateText(title)}</Title>
        <StatusBadge $status={status}>{status}</StatusBadge>
        <Description title={description}>{description}</Description>
      </ContentSection>
      <ActionsSection>
        <ActionButton onClick={onEdit}>
          <EditIcon size={16} color="#2D6CDF" />
          Edit
        </ActionButton>
        <ActionButton onClick={onDelete} $delete>
          <DeleteIcon size={16} color="#FB2C36" />
          Delete
        </ActionButton>
      </ActionsSection>
    </Card>
  );
};

export default ProductCard;
